import './confirm-dialog.scss';

import * as ConfirmDialogController from './confirm-dialog.controller';
import * as $gzConfirmDialog from './confirm-dialog.service';

export default angular.module('gazelle.components.confirmDialog', [
  'ngMaterial',
])
  .controller(ConfirmDialogController.name, ConfirmDialogController.default)
  .factory($gzConfirmDialog.name, $gzConfirmDialog.default)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/confirm/confirm-dialog.module.js